<template>
    <div class="flex items-center relative mr-2">
          <div v-show="isHidden" class="w-full">
             <div class="w-full block px-1 py-2 bg-white border-2 border-black text-sm text-black no-underline mr-2 rounded-b-lg shadow-lg">
              <div class="flex flex-row -mx-1 -mt-2 h-3 mb-1 border-b border-black">
                  <div class="w-2/3 border border-white" :style="firstcolor"></div>
                  <div class="w-1/3 border border-white" :style="secondcolor"></div>
              </div>
                {{ name }}<span class="border-l border-gray-500 pl-1 mx-1">{{ initialaccuracy }}</span>
              </div>
              <a v-on:click="isHidden = !isHidden" class="text-xs py-1 px-3 rounded text-white no-underline bg-green-500 whitespace-no-wrap hover:bg-green-600 cursor-pointer">Confirm Pattern</a>
          </div>
          <div v-if="!isHidden" class="flex flex-col w-full items-center ml-1">
            <div class="w-full px-3 py-2 bg-green-100 border-2 border-green-600 text-base text-green-600 mr-2 rounded-b">
              <div class="flex flex-row -mx-3 -mt-2 h-3 mb-1 border-b border-green-600">
                <div class="w-2/3 border border-white" :style="firstcolor"></div>
                <div class="w-1/3  border border-white" :style="secondcolor"></div>
              </div>
              {{ name }}
               <br>
               <span class="text-xs leading-snug">Confirming Pattern</span>
            </div>
            <div class="w-full bg-white px-2 py-0 relative mr-2">
              <div class="verification-confirm-btn" v-show="isSure">
                <span class="text-xs mb-1 leading-snug">Set Accuracy and Save Type</span>
                <vue-slider v-model="value" :min="60" :max="99" :tooltip-formatter="formatter"></vue-slider>
                <a v-on:click="isSure = !isSure" class="commitbutton p-0 py-1 inline-block btn cursor-pointer text-xs w-full shadow-lg mt-1">Save Pattern <i aria-hidden="true" class="material-icons align-middle text-sm">save</i></a>
              </div>
            </div>
          </div>
          <div v-if="!isSure" class="bg-red-600 text-white w-full p-2 absolute top-0 text-xs z-50 -ml-1 shadow-md rounded" v-click-outside="onClickOutside">
            <i aria-hidden="true" class="material-icons align-middle text-yellow-400">report_problem</i><br>
            <strong>Note:</strong> Only an authorized person may confirm this as their best-fit type.
          </div>
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import VueSlider from 'vue-slider-component'


  export default {
    components: {
      VueSlider
    },
    props: {
        route:'',
        type: '',
        name: '',
        userid: '',
        initialaccuracy: '',
        primarycolor:'',
        secondarycolor:'',
    },

    data() {
      return {
        isHidden: true,
        isSure: true,
        success: false,
        loaded: true,
        user_id: this.userid,
        confirmed_type: this.type,
        value: this.initialaccuracy,
        formatter: '{value}%',
        firstcolor: {
          backgroundColor: this.primarycolor
        },
        secondcolor: {
          backgroundColor: this.secondarycolor
        },
      }
    },
    
    directives: {
      clickOutside: vClickOutside.directive
    },
    
    methods: {
      onClickOutside (event) {
          this.isSure = !this.isSure
      },

    },
  }
</script>
